export const POINTS_WATCHING = "Points Watching"

// tooltip names
export const BACK = "Back"


export const POINTS_WATCHING_CUSTOMER_FIELDS = [
    {},
    {id: 'pointPicture', label: 'Points Picture', align: "center"},
    {id: 'idPicture', label: 'ID Picture', align: "center"},
    {id: 'customer', label: 'Customer', align: "center"},
    {id: 'points', label: 'Points ', align: "center"},
    {id: 'signInDate', label: 'Date Time Given', align: "center"},
    {id: 'ticket', label: 'Machine', align: "center"},
    {id: 'type', label: 'Given By', align: "center"},
]
